import { useCallback, useSyncExternalStore } from 'react';
import { getScoutFocus, setScoutFocus } from '../utils/prefStorage';

// Shared, persisted "focus mode" flag. Toggled from the Scout page and read by
// the ApplicationShell to drop the persistent sidebar so Scout can go
// full-bleed on large screens. Backed by localStorage and synced across all
// components/tabs via useSyncExternalStore (no provider needed).
const listeners = new Set<() => void>();

const subscribe = (callback: () => void) => {
  listeners.add(callback);
  window.addEventListener('storage', callback);
  return () => {
    listeners.delete(callback);
    window.removeEventListener('storage', callback);
  };
};

const emit = () => listeners.forEach((l) => l());

export const useFocusMode = () => {
  const focus = useSyncExternalStore(
    subscribe,
    getScoutFocus,
    () => false // server snapshot — focus is never on during SSR
  );

  const setFocus = useCallback((value: boolean) => {
    setScoutFocus(value);
    emit();
  }, []);

  const toggle = useCallback(() => {
    setScoutFocus(!getScoutFocus());
    emit();
  }, []);

  return { focus, setFocus, toggle };
};
